export const truncateString = (str, num) => {
  // If the length of str is less than or equal to num
  // just return str--don't truncate it.
  if (str.length <= num) {
    return str;
  }
  // Return str truncated with '...' concatenated to the end of str.
  return str.slice(0, num) + "...";
};

export const replaceNewLine = str => {
  return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
};

export const getParamsFromUrl = (url,param = '') => {
    let vars = [];
     url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
    });
     console.log(vars);
     return param === '' ? vars : vars[param];
};
export const validURLFb= (str, element) => {
    str = str+'';
    let check = true;
    let arrCheck = [element];
    for (let i=0; i< arrCheck.length; i++) {
        if (str.indexOf(arrCheck[i]) === -1) {
            check = false;
            break;
        }
    }
    return check;
};

export const getErrorMsg = (err) => {
    let message = "Đã có một vài lỗi xảy ra, vui lòng thư lại sau !";
    if (err.response.data.message) {
        message = err.response.data.message;
    }
    // if (err.response.status === 422) {
    //     let error = Object.values(err.response.data.errors);
    //     error.forEach(function (val, ind) {
    //         if (ind === 0) {
    //             message = val[0];
    //         }
    //     });
    // }
    return message;
};

export const formatCurrency= (value) => {
    let floatValue = (value).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return floatValue.substring(0, floatValue.length - 2);
};

export const checkComment= (value) => {
   return /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/.test(value) || /[\\!\\*\\@\\:\\^\\?\\&\\<\\>]/.test(value);
};

export default { truncateString, replaceNewLine, getParamsFromUrl, getErrorMsg, formatCurrency, checkComment };
